(() => {
  'use strict';
  const configNode = document.getElementById('PreparationCartConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const normalise = value => String(value || '').toUpperCase().replace(/Χ/g, 'X').replace(/Μ/g, 'M').replace(/[\s–—]/g, '');
  const potencyOf = value => {
    const text = normalise(value);
    const lm = text.match(/LM(\d+)/);
    if (lm) { const n = Number(lm[1]); return n >= 1 && n <= 30 ? `LM${n <= 12 ? '1–12' : n <= 18 ? '13–18' : n <= 24 ? '19–24' : '25–30'}` : null; }
    const match = text.match(/(?:^|\/|\|)(200CH|30CH|12CH|200C|30C|12C|50M|10M|1M|12X|6X)(?:$|\/|\|)/);
    return match ? match[1].replace(/^(200|30|12)C$/, '$1CH') : null;
  };
  const contextOf = item => {
    const variant = String(item.variantTitle || '');
    const kindText = `${item.title || ''} ${variant} ${item.unit || ''}`.toLowerCase();
    const kind = /pills/.test(kindText) ? 'pills' : /caps|κάψουλ/.test(kindText) ? 'capsules' : /globul|granul|pellet/.test(kindText) ? 'globules' : /trituration|schuessler|σκόν|σκον|schüssler/.test(kindText) ? 'powders' : /υγρ|buvable|ml|φιαλί/.test(kindText) ? 'liquids' : null;
    const pack = variant.match(/(\d+(?:[.,]\d+)?)\s*(ml|g|gr|γρ)\b/i);
    return { kind, potency: potencyOf(variant), amount: pack ? Number(pack[1].replace(',', '.')) : Number(item.quantity), packages: pack ? Number(item.quantity) : 1 };
  };
  const quote = (catalogue, context) => {
    const { kind, potency, amount, packages = 1 } = context;
    const unknown = { status: 'needs_review', label: 'Χρειάζεται κοστολόγηση', cents: null };
    if (!kind || !potency || !Number.isFinite(amount) || amount <= 0 || !Number.isInteger(packages) || packages < 1) return unknown;
    const cents = catalogue?.tables?.[kind]?.[String(amount)]?.[potency];
    if (!Number.isInteger(cents) || cents < 0) return unknown;
    return { status: 'catalogued', cents: cents * packages, currency: 'EUR', version: catalogue.version, label: (cents * packages / 100).toFixed(2) + ' EUR' };
  };
  window.PreparationPricing = {
    contextOf, potencyOf, quote,
    ready: fetch(config.pricesUrl, { credentials: 'same-origin' }).then(response => {
      if (!response.ok) throw new Error('Price catalogue unavailable');
      return response.json();
    }).catch(() => null)
  };
})();
